<script setup lang="ts">
import DialogCloseIcon from "@/assets/editViewIcons/DialogCloseIcon.vue";
import NamaIcon from "@/components/icons/NamaIcon.vue";
import {useDialogPluginComponent} from "quasar";
import LoginUtils from "@/utils/login/LoginUtils.ts";
import {useQRCode} from '@vueuse/integrations/useQRCode'
import {useLoginInfoStore} from "@/stores/loginInfo.ts";
import {storeToRefs} from "pinia";
import {onMounted, onUnmounted} from "vue";

const {qrCodeDialogVisible} = storeToRefs(useLoginInfoStore())

const {reqId} = defineProps<{
  reqId: string
}>()
const {dialogRef, onDialogCancel} = useDialogPluginComponent()
const qrcode = useQRCode(LoginUtils.genMPSAuthURL(reqId))

onMounted(() => {
  qrCodeDialogVisible.value = true
})

onUnmounted(() => {
  qrCodeDialogVisible.value = false
})
</script>

<template>
  <q-dialog ref="dialogRef" v-model="qrCodeDialogVisible" transition-hide="jump-down" transition-show="jump-up">
    <q-card class="tw-relative tw-min-w-96 dark:tw-bg-namaBackground-deep-dark tw-rounded-md" dir="ltr">
      <q-toolbar
        class="tw-flex tw-sticky tw-left-0 tw-translate-x-0 tw-gap-3 !tw-rounded-none tw-items-center tw-px-4 tw-justify-between tw-bg-primary-lighttw-text-white">
        <q-toolbar-title class="tw-flex tw-items-center tw-gap-2">
          <NamaIcon default-icon="qr_code" class="active-white"/>
          <span v-text="'Generate QR-Code To Mobile App Login'" class="dark:tw-text-white"/>
        </q-toolbar-title>
        <q-avatar square class="tw-w-5 tw-cursor-pointer" @click="onDialogCancel">
          <NamaIcon default-icon="close" class="active-white"/>
        </q-avatar>
      </q-toolbar>
      <q-card-section class="!tw-p-2 tw-w-full tw-flex tw-flex-col tw-gap-2 tw-items-center">
        <p v-text="'Scan this QR Code Or Use The Link Below.'" class="dark:tw-text-white tw-text-lg tw-mb-1"/>
        <div v-text="'Scan Me'" class="dark:tw-text-white tw-text-xl tw-font-semibold tw-text-center"/>
        <q-img :src="qrcode" class="tw-max-w-80 tw-block" alt="QR Code"/>
        <a v-text="'Click Here (or Copy Link) If You do not have a phone'" class="tw-text-lg tw-font-semibold" :href="LoginUtils.genMPSAuthURL(reqId)"
           target="_blank"/>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>
